import { apiPost } from "./api";
import { getRecaptchaToken } from "./recaptcha";

export interface ContactEnquiry {
  name: string;
  email: string;
  subject?: string;
  message: string;
}

/**
 * Routes a general enquiry to Customer Support: mints a reCAPTCHA v3 token, then POSTs to
 * the real `/api/public/enquiries/contact` endpoint (verifies the token, writes the enquiry
 * to Firestore, returns a server-issued reference number) — same pattern as
 * supplierEnquiry.ts/franchiseEnquiry.ts/b2bEnquiry.ts. No client-side simulation.
 */
export async function submitContactEnquiry(
  enquiry: ContactEnquiry,
): Promise<{ ok: true; referenceNumber: string }> {
  const recaptchaToken = await getRecaptchaToken("contact_enquiry");
  return apiPost<{ ok: true; referenceNumber: string }>("/public/enquiries/contact", {
    ...enquiry,
    recaptchaToken,
  });
}
